import { useCallback, useEffect } from 'react';

export function useOnWindowFocus(onFocus: () => Promise<void>) {
	const onVisibilityChange = useCallback(() => {
		if (document.visibilityState === 'visible') {
			onFocus();
		}
	}, [onFocus]);
	useEffect(() => {
		if (window?.addEventListener) {
			window.addEventListener('visibilitychange', onVisibilityChange, false);
			window.addEventListener('focus', onFocus, false);
		}

		return () => {
			if (window?.removeEventListener) {
				window.removeEventListener('visibilitychange', onVisibilityChange);
				window.removeEventListener('focus', onFocus);
			}
		};
	});
}
